module.exports = __webpack_public_path__ + "static/media/nft_banner.8d5d24ee.jpg";